var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSophareLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 793,
    height: 896,
    viewBox: "0 0 793 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.619 19.4464L71.3155 190.645L59.5084 206.243L51.5201 223.569L48.4658 251.649L56.736 281.845L84.4152 317.682L115.351 353.263L361.885 196.485C367.604 192.848 371.068 186.54 371.068 179.763L371.068 36.1704C371.068 20.5369 353.813 11.0593 340.619 19.4464Z",
    fill: "url(#paint0_linear_196_140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.476 876.429L720.78 705.23L732.587 689.632L740.575 672.306L743.629 644.227L735.359 614.03L707.68 578.193L676.744 542.612L430.21 699.39C424.491 703.027 421.027 709.335 421.027 716.113L421.027 859.705C421.027 875.338 438.283 884.816 451.476 876.429Z",
    fill: "url(#paint1_linear_196_140)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3156 444.719L340.62 615.918C353.813 624.305 371.068 614.828 371.068 599.194L371.068 455.604C371.068 448.825 367.603 442.517 361.883 438.88L71.3156 254.164C51.9013 239.367 53.0684 224.86 71.3156 190.646C-89.1632 343.073 71.3156 444.719 71.3156 444.719Z",
    fill: "url(#paint2_radial_196_140)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.068 824.561C371.068 856.431 371.068 872.367 360.791 878.011C350.514 883.656 337.067 875.107 310.171 858.009L71.3432 706.184C71.3273 706.174 71.3193 706.169 71.3173 706.168C71.3153 706.166 71.3147 706.166 71.3136 706.165C70.7644 705.816 -39.9723 635.313 15.5806 523.866C22.697 509.589 26.2552 502.451 34.7451 500.087C43.235 497.724 50.8704 502.568 66.1412 512.257L70.7907 515.207C70.964 515.342 71.1389 515.476 71.3156 515.611L352.697 694.488C361.681 700.199 366.173 703.055 368.621 707.511C371.068 711.967 371.068 717.29 371.068 727.936L371.068 824.561Z",
    fill: "url(#paint3_radial_196_140)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M720.779 451.248L451.475 280.049C438.282 271.662 421.026 281.139 421.026 296.773L421.026 440.363C421.026 447.142 424.491 453.45 430.212 457.087L720.779 641.803C740.193 656.6 739.026 671.107 720.779 705.322C881.258 552.894 720.779 451.248 720.779 451.248Z",
    fill: "url(#paint4_radial_196_140)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.026 71.3956C421.026 39.5251 421.026 23.5899 431.303 17.9453C441.58 12.3007 455.028 20.8497 481.924 37.9476L720.752 189.772C720.767 189.783 720.775 189.788 720.777 189.789C720.779 189.79 720.78 189.791 720.781 189.791C721.33 190.14 832.067 260.643 776.514 372.091C769.398 386.367 765.84 393.506 757.35 395.869C748.86 398.232 741.224 393.388 725.954 383.699L721.303 380.749C721.13 380.614 720.955 380.48 720.779 380.345L439.398 201.469C430.414 195.757 425.921 192.902 423.474 188.446C421.026 183.989 421.026 178.666 421.026 168.021L421.026 71.3956Z",
    fill: "url(#paint5_radial_196_140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_140",
    x1: 71.8136,
    y1: 239.985,
    x2: 383.432,
    y2: 156.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F99FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_140",
    x1: 743.629,
    y1: 719.199,
    x2: 421.027,
    y2: 719.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACA7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_196_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.316 335.671) rotate(35.008) scale(390.384 409.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493565,
    stopColor: "#534BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D34C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_196_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.964 781.572) rotate(-149.705) scale(352.662 218.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D34C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#534BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8780FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_196_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(740.779 560.296) rotate(-144.992) scale(390.384 409.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493565,
    stopColor: "#534BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D34C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_196_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(440.13 114.385) rotate(30.2951) scale(352.662 218.065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D34C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#534BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8780FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSophareLogo);
export default __webpack_public_path__ + "static/media/sophare-logo.51454a06c8bd951e5f2e7efb0ddadb63.svg";
export { ForwardRef as ReactComponent };